import { useCallback, useState } from 'react';

function read<T>(key: string, fallback: T): T {
    try {
        const raw = window.localStorage.getItem(key);
        return raw === null ? fallback : (JSON.parse(raw) as T);
    } catch {
        return fallback;
    }
}

/** Per-browser preference (e.g. "hide closed trails"), tolerant to blocked storage. */
export function useLocalStorage<T>(key: string, fallback: T): [T, (value: T) => void] {
    const [value, setValue] = useState<T>(() => read(key, fallback));
    const set = useCallback(
        (next: T) => {
            setValue(next);
            try {
                window.localStorage.setItem(key, JSON.stringify(next));
            } catch {
                // private mode or storage disabled
            }
        },
        [key],
    );
    return [value, set];
}
